import axiosInstance from './axiosInstance';

let currentUserRequestPromise = null;

// 用户认证相关API
export const userApi = {
  // 用户登录
  login: async (username, password) => {
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    
    try {
      const response = await axiosInstance.post('auth/login', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        validateStatus: function (status) {
          return status >= 200 && status < 400;
        }
      });
      
      const normalized = response?.data || response;
      const loginData = normalized?.code === 0 && normalized?.data
        ? normalized.data
        : normalized;
      
      if (!loginData.access_token) {
        throw new Error(normalized?.message || '登录响应中缺少访问令牌');
      }
      
      const token = `Bearer ${loginData.access_token}`;
      localStorage.setItem('token', token);
      axiosInstance.defaults.headers.common['Authorization'] = token;
      
      return loginData;
    } catch (error) {
      throw error;
    }
  },
  
  // 修改用户密码
  changePassword: (data) => axiosInstance.post('auth/change-password', data),
  
  // 获取当前用户信息
  getCurrentUser: async () => {
    try {
      if (currentUserRequestPromise) {
        return await currentUserRequestPromise;
      }

      const token = localStorage.getItem('token');
      
      if (!token) {
        throw new Error('No token available');
      }
      
      // 确保token格式正确
      if (!token.startsWith('Bearer ')) {
        const correctedToken = `Bearer ${token.split(' ')[1]}`;
        localStorage.setItem('token', correctedToken);
        axiosInstance.defaults.headers.common['Authorization'] = correctedToken;
      }
      
      currentUserRequestPromise = (async () => {
        const response = await axiosInstance.get('users/me', {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        });
        const normalized = response?.data || response;
        const userData = normalized?.code === 0 && normalized?.data
          ? normalized.data
          : normalized;

        // 存储用户信息
        if (userData) {
          localStorage.setItem('user', JSON.stringify(userData));
        }
        
        return userData;
      })();

      return await currentUserRequestPromise;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      // 如果是401错误，清除token和用户信息
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      throw error;
    } finally {
      currentUserRequestPromise = null;
    }
  },
  
  // 更新当前用户信息
  updateProfile: (data) => axiosInstance.put('users/me', data),
  
  // 获取所有用户列表（仅管理员）
  getAllUsers: (params) => axiosInstance.get('users', { params }),
  
  // 创建新用户（仅管理员）
  createUser: (data) => axiosInstance.post('users', data),
  
  // 获取特定用户信息（仅管理员）
  getUser: (id) => axiosInstance.get(`users/${id}`),
  
  // 更新特定用户信息（仅管理员）
  updateUser: (id, data) => axiosInstance.put(`users/${id}`, data),
  
  // 重置用户密码（仅管理员）
  resetPassword: (id, data) => axiosInstance.post(`users/${id}/reset-password`, data),
  
  // 删除用户（仅管理员）
  deleteUser: (id) => axiosInstance.delete(`users/${id}`)
}; 